import { convertPxToVw, convertVwToPx } from 'utils/helpers';

// The precision runtime CSS writes a px dimension's vw with (`createTokenDeclarations`, `normalizePlatformStyleValue`)
const RUNTIME_VW_DIGITS = 2;
const PX_VALUE = /^[-+]?(?:\d+(?:\.\d+)?|\.\d+)px$/i;

/**
 * The px a px dimension renders at on a canvas `width` wide when it is authored on a platform `authoredWidth` wide.
 * Runtime writes it as vw at the authored platform's reference width, so any other width scales it. `decimals` rounds
 * the result as the Inspector field does. Anything else (rem, %, a plain number) renders as authored: undefined.
 */
export function getPlatformDimensionPx({
	value,
	authoredWidth,
	width,
	decimals,
}: {
	value: string | number;
	authoredWidth: number;
	width: number;
	decimals: number;
}): number | undefined {
	const text = String(value).trim();
	if (!PX_VALUE.test(text)) return undefined;
	return Number(convertVwToPx(convertPxToVw(text, RUNTIME_VW_DIGITS, authoredWidth), decimals, width));
}
